<div class="panel b">
  <div class="d-flex justify-content-between align-items-center mb-3 mt-6">
    <div class="fs-4 d-flex align-items-center edit-btn">Redemption Details
      <p-toggleButton
        *ngIf="(('redemptionInstructions' | groupFieldCheck: groupAttributes) || ('digitalTerms' | groupFieldCheck: groupAttributes)) && !isActionsDisabled"
        class="ml-3 lh-1"
        [(ngModel)]="isEditRedemptionDetails"
        [disabled]="isActionsDisabled"
        offIcon="pi pi-pencil" onIcon="pi pi-times"
        onLabel="Cancel Edit" offLabel="Edit"
        (click)="onCancel()"
      ></p-toggleButton>
    </div>
    <div class="buttons-block" *ngIf="isEditRedemptionDetails">
      <ng-container>
        <button  id="rd-savebtn" [disabled]="hasMaxLengthError"
                 class="mb-sm btn btn-primary fa fa-save"
                 type="button"
                 (click)="onSave()"
        >Save</button>
      </ng-container>
    </div>
  </div>
  <div class="panel-body">
    <ng-container *ngIf="!('redemptionInstructions' | groupFieldCheck: groupAttributes) && !('digitalTerms' | groupFieldCheck: groupAttributes)">
      <p>No fields in product level</p>
    </ng-container>
    <form [formGroup]="redemptionDetails"
          *ngIf="('redemptionInstructions' | groupFieldCheck: groupAttributes) || ('digitalTerms' | groupFieldCheck: groupAttributes)">
      <div formGroupName="overridableRedemptionDetails">
        <div class="row mb-3" *ngIf="'redemptionInstructions' | groupFieldCheck: groupAttributes">
          <div class="col-lg-12">
            <div class="form-group" [ngClass]="{'warning' : showError('overridableRedemptionDetails.redemptionInstructionsCustomer') && data?.dpamRequest?.productDigital}">
              <label class="pt-1 pb-1">Redemption Instructions</label><label style="color:red;" *ngIf="data?.dpamRequest?.productDigital">*</label>
              <div class="document-editor">
                <app-prime-editor [form]="overridableRedemptionDetails"
                                  [formCName]="'redemptionInstructionsCustomer'"
                                  [disabled]="isEditRedemptionDetails ? null : true"
                ></app-prime-editor>
              </div>
              <span class="warning-text" *ngIf="checkRequired('overridableRedemptionDetails.redemptionInstructionsCustomer') && data?.dpamRequest?.productDigital">This is a required field, fill in before submitting request</span>
              <span class="warning-text" *ngIf="checkMaxLength('overridableRedemptionDetails.redemptionInstructionsCustomer')">{{showMaxLengthErrorMessage('overridableRedemptionDetails.redemptionInstructionsCustomer')}}</span>
            </div>
          </div>
          <br/>
        </div>
        <div class="row mb-3" *ngIf="'digitalTerms' | groupFieldCheck: groupAttributes">
          <div class="col-lg-12">
            <div class="form-group" [ngClass]="{'warning' : showError('overridableRedemptionDetails.digitalTerms') && data?.dpamRequest?.productDigital}">
              <label class="pt-1 pb-1">Digital Terms</label><label *ngIf="data?.dpamRequest?.productDigital" style="color:red;">*</label>
              <div class="document-editor">
                <app-prime-editor  [form]="overridableRedemptionDetails"
                                   [formCName]="'digitalTerms'"
                          [disabled]="isEditRedemptionDetails ? null : true"
                ></app-prime-editor>
              </div>
              <span class="warning-text"
                    *ngIf="checkRequired('overridableRedemptionDetails.digitalTerms') && data?.dpamRequest?.productDigital">This is a required field, fill in before submitting request</span>
              <span class="warning-text" *ngIf="checkMaxLength('overridableRedemptionDetails.digitalTerms')">{{showMaxLengthErrorMessage('overridableRedemptionDetails.digitalTerms')}}</span>
            </div>
          </div>
          <br/>
        </div>
        <div class="row mb-3" *ngIf="!groupAttributes">
          <div class="col-lg-12">
            <div class="form-group">
              <label class="pt-1 pb-1">Compatibility</label>
              <div class="document-editor">
                <app-prime-editor [form]="overridableRedemptionDetails"
                                  [formCName]="'compatibility'"
                                  [disabled]="isEditRedemptionDetails ? null : true"
                ></app-prime-editor>
              </div>
              <span class="warning-text" *ngIf="checkMaxLength('overridableRedemptionDetails.compatibility')">{{showMaxLengthErrorMessage('overridableRedemptionDetails.compatibility')}}</span>
            </div>
          </div>
          <br/>
        </div>
        <div class="row mb-3" *ngIf="!groupAttributes">
          <div class="col-lg-12">
            <div class="form-group">
              <label class="pt-1 pb-1">Legal Disclaimer</label>
              <div class="document-editor">
                <app-prime-editor [form]="overridableRedemptionDetails"
                                  [formCName]="'legalDisclaimer'"
                                  [disabled]="isEditRedemptionDetails ? null : true">
                </app-prime-editor>
              </div>
              <span class="warning-text" *ngIf="checkMaxLength('overridableRedemptionDetails.legalDisclaimer')">{{showMaxLengthErrorMessage('overridableRedemptionDetails.legalDisclaimer')}}</span>
            </div>
          </div>
        </div>
      </div>

      <br/>
      <div class="row mb-3" *ngIf="!groupAttributes">
        <div class="col-lg-12">
          <div class="form-group" [ngClass]="{'warning' : checkMaxLength('expiration')}">
            <label class="pt-1 pb-1">Expiration</label>
            <input class="form-control"
                   [attr.disabled]="isEditRedemptionDetails ? null : true"
                   pInputText
                   [readOnly]="!isEditRedemptionDetails"
                   formControlName="expiration"/>
            <span class="warning-text" *ngIf="checkMaxLength('expiration')">{{showMaxLengthErrorMessage('expiration')}}</span>
          </div>
        </div>
        <br/>
      </div>
      <div class="row mb-3" *ngIf="!groupAttributes">
        <div class="col-lg-12">
          <div class="form-group" [ngClass]="{'warning' : checkMaxLength('productNotes')}">
            <label class="pt-1 pb-1">Product Notes</label>
            <textarea class="form-control"
                      [attr.disabled]="isEditRedemptionDetails ? null : true"
                      [readOnly]="!isEditRedemptionDetails"
                      cols="5" formControlName="productNotes"
                      (keydown.enter)="onEditorEnterPressed($event)"></textarea>
            <span class="warning-text" *ngIf="checkMaxLength('productNotes')">{{showMaxLengthErrorMessage('productNotes')}}</span>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
